import { memo } from 'react';

import { ShareDesignFontRow } from '~/components/ShareModal/components/ShareDesignFontRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/** Headline-font row, bound to the design context. */
export const CreateShowcaseDesignHeadlineFontRow = memo(() => {
  const {
    typographyDisabled,
    customTypographyEnabled,
    fontFamily,
    fontVariant,
    brandFonts,
    selectedBrandFontId,
    handleChangeFont,
    handleClearFont,
    handleSelectBrandFont,
  } = useCreateShowcaseDesign();

  return (
    <ShareDesignFontRow
      brandFonts={brandFonts}
      data-testid="CREATE_COLLECTION_LINK_DESIGN_FONT_ROW"
      disabled={typographyDisabled}
      showUpsell={!customTypographyEnabled}
      fontFamily={fontFamily}
      label="Headline font"
      onChange={handleChangeFont}
      onClear={handleClearFont}
      onSelectBrandFont={handleSelectBrandFont}
      selectedBrandFontId={selectedBrandFontId}
      variant={fontVariant}
    />
  );
});

CreateShowcaseDesignHeadlineFontRow.displayName = 'CreateShowcaseDesignHeadlineFontRow';
